var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{on:{"toggleDrawer":function($event){return _vm.$refs.navDrawer.toggleDrawer()}}},[(_vm.user)?_c('navdrawer',{key:_vm.company,ref:"navDrawer"}):_vm._e(),_vm._v(" "),_c('navbar'),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('router-view',{key:_vm.$route.fullPath,on:{"hide-drawer":_vm.hideDrawer}})],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352fa9ce","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/default.vue
// module id = qGGB
// module chunks = 113